module.exports = __webpack_public_path__ + "static/img/arrow.f3906ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow.png
// module id = qNF3
// module chunks = 1 3